const l = {
  "scale-on-scroll": "scale-on-scroll"
};
export {
  l as default
};
